import { FormationDetailProps } from "@/types/formation";

export const habilitationElectriqueB0H0Formation: FormationDetailProps = {
  id: "16",
  title: "Formation Habilitation Électrique B0/H0/HOV",
  description: "Formation permettant aux électriciens de travailler en sécurité dans des environnements électriques selon les préconisations de la norme NFC 18-510.",
  duration: "14 heures (2 jours)",
  category: "Habilitations",
  imageSrc: "/images/formations/habilitation.webp",
  slug: "habilitation-electrique-b0-h0",
  reference: "F-B0/H0/HOV EXECUTANT",
  price: "Sur devis – nous contacter",
  targetAudience: "Toutes personnes ayant à réaliser des travaux non électriques dans un environnement électrique (peinture, plâtrerie, nettoyage de surface, agents de sécurité, magasiniers, agents de production...)",
  prerequisites: "Être capable de comprendre les instructions de sécurité",
  objectives: [
    "Respecter les prescriptions de sécurité liées à la réglementation et aux limites du champ d'intervention des personnes habilitées B0/H0/HOV",
    "Identifier les types de courant, de contact, leurs effets sur le corps humain et les moyens de protection collective et individuelle existants",
    "Identifier les différents acteurs ainsi que leurs rôles et missions"
  ],
  program: [
    {
      title: "Partie théorique 70%",
      items: [
        "L'HABILITATION ÉLECTRIQUE",
        "Définition des grandeurs électriques, intensité et accidents correspondants",
        "L'ÉVALUATION ET LA PRÉVENTION DES ACCIDENTS DU TRAVAIL D'ORIGINE ÉLECTRIQUE",
        "Les différents acteurs de l'industrie électrique",
        "Les mesures de prévention en vue de la réalisation d'opérations d'ordre électrique",
        "Les principes de mise en œuvre des opérations",
        "LES DANGERS DU COURANT ÉLECTRIQUE",
        "Contact direct, contact indirect et le court",
        "Les effets du courant sur le corps humain",
        "Les différents facteurs de gravité d'une électrisation et court-circuit",
        "Les installations sur les accidents d'origine électrique",
        "LES EFFETS DU COURANT SUR LE CORPS HUMAIN",
        "Les conséquences d'un accident électrique",
        "La notion direct et la contact indirect",
        "La résistance du corps humain",
        "LES PROTECTIONS CONTRE LES CONTACTS DIRECTS ET INDIRECTS",
        "Les zones de circulation, les principes de mise à terre",
        "Les différentes classes de matériel",
        "L'isolation renforcée et la séparation des circuits",
        "La TBTS et la TBTP",
        "LES ÉQUIPEMENTS DE PROTECTION",
        "Les équipements de protection individuels ou collectifs (gants, casque, tapis isolant...)",
        "La vérification des EPI",
        "LES OUTILS ET LE MATÉRIEL DE TRAVAIL",
        "La réglementation et l'état de l'art (meuleuse, CIL, conforme aux normes, prescription de conception)",
        "L'outillage à main utilisé en électricité générale",
        "Les équipements de montage",
        "LES CONDUITES À TENIR",
        "En cas d'accident ou d'incident d'origine électrique",
        "En cas d'incendie dans un local à risque",
        "Les conduites particulières",
        "La délimitation de la zone de travail",
        "Le rôle du H0-B0-HOV",
        "NOTIONS ÉLÉMENTAIRES D'ÉLECTRICITÉ",
        "La production de courant",
        "Les unités de mesures électriques",
        "Les différents types de courant",
        "LES DOMAINES DE TENSION, LES OUVRAGES ET INSTALLATIONS",
        "Les limites légales des domaines",
        "Le rôle des intervenants",
        "LES ZONES D'ENVIRONNEMENT",
        "Le classement des zones d'environnement",
        "Les distances à respecter",
        "LES TITRES D'HABILITATION",
        "Les différents titres, les symboles et les limites d'habilitation",
        "PRÉVENTION DES RISQUES ÉLECTRIQUES",
        "Les protections et les équipements",
        "Les procédures de protection",
        "Les consignes particulières (charge de travaux, charge d'exploitation électrique)",
        "LES OPÉRATIONS D'ORDRE NON ÉLECTRIQUE",
        "En hors tension",
        "Dans un environnement électrique",
        "Les opérations particulières, la surveillance de la zone de travail, le balisage de la zone de travail"
      ]
    },
    {
      title: "Partie pratique 30%",
      items: [
        "CAS CONCRET",
        "Mise en situation pratique sur un ouvrage ou une installation types: analyser les risques dans une situation caractéristique",
        "VISITE DES INSTALLATIONS (INTRA-ENTREPRISE)",
        "Présentation des installations et locaux concernés par le titre d'habilitation, identification des mesures de prévention applicables"
      ]
    }
  ],
  numberOfParticipants: "10 Participants",
  maintainingKnowledge: "07h00 tous les 3 ans",
  pedagogicalMethods: [
    "Exposés interactifs, analyse de situations de travail, démonstrations par le formateur, mise en situation pratique, exercice sur site"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs conformément aux préconisations de la NFC 18-510",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par évaluation des acquis.",
  accessibilityCriteria: "Accessible aux personnes en situation de handicap. Nous contacter pour toute demande spécifique.",
  registrationProcess: [
    "Inscription en ligne ou par téléphone",
    "Règlement des frais de formation",
    "Réception de la convocation et des supports pédagogiques"
  ],
  intervenant: "Formateur certifié et expérimenté dans le domaine de l'habilitation électrique",
  formatterInfo: {
    name: "SDPSI Formation",
    phone: "01 23 45 67 89",
    email: "contact@sdpsi-formations.fr",
    website: "www.sdpsi-formations.fr"
  }
};
